import type { I18nLocale } from "@/modules/i18n/types"

export const DEFAULT_LOCALE: I18nLocale = "en"

/**
 * This list is related to the opened public WWW website.
 */
export const PUBLIC_LOCALES: I18nLocale[] = ["fr", "da", "de", "es", "nl", "en"]
